import { useRef, useEffect } from "react";
export const usePrevious = (value) => {
    const ref = useRef(undefined);
    useEffect(() => {
        ref.current = value;
    });
    return ref.current;
};
export const usePreviousWithRef = (value) => {
    const returnRef = useRef(undefined);
    returnRef.current = usePrevious(value);
    return returnRef;
};
// export function usePreviousRef<T> (value: React.MutableRefObject<T | undefined>) {
//     const ref = useRef<T | undefined>(undefined);
//     useEffect(() => {
//         ref.current = value.current;
//     });
//     return ref.current;
// }
